import React from 'react';
import { Typography } from '@mui/material';
import ActionDialog from './ActionDialog';

const CancelConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  message = '내용 입력을 취소하시겠습니까?',
}) => {
  return (
    <ActionDialog open={open} onClose={onClose} onConfirm={onConfirm}>
      <Typography sx={{ textAlign: 'center' }}>{message}</Typography>
    </ActionDialog>
  );
};

export default CancelConfirmDialog;
